<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div style=" overflow-x: hidden">
        <v-row style="padding:1% 2%; height: 100px;">
          <v-col xs="10" sm="10" md="10" lg="10">
            <h2>ของรางวัล</h2>
          </v-col>
          <v-col right xs="2" sm="2" md="2" lg="2" class="displayxs">
            <v-btn
              class="red--text"
              large
              outlined
              color="indigo"
              @click=";(showData = false), (formAddData = true)"
              v-if="showData"
            >
              เพิ่มของรางวัล
            </v-btn>
            <v-btn
              large
              outlined
              color="indigo"
              @click="
                ;(showData = true),
                  (formAddData = false),
                  (formUpdateData = false),
                  clearData()
              "
              v-if="!showData"
            >
              ยกเลิก
            </v-btn>
          </v-col>
        </v-row>
        <v-divider style="padding-top:0; magin: 0px 0px"></v-divider>
        <!-- add Data reward -->
        <v-container
          style="padding: 0px 15px;
            overflow-y:hidden"
        >
          <v-form ref="form" v-model="valid" lazy-validation v-if="formAddData">
            <v-row style="padding-top: 20px;">
              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="6"
                lg="6"
                style="background-color:"
              >
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">รูปของรางวัล</p>
                  </v-col>
                  <!-- <v-col
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:5px auto; text-align: center;"
                    justify="center"
                    ><v-card
                      @click="$refs.filePickerField.click()"
                      class="image-input"
                      :style="{
                        'background-image': `url(${pictureUrlPreview})`,
                        'background-size': 'contain',
                        'background-position': 'center center',
                        'background-repeat': 'no-repeat',
                        'background-color': '#E8EBF4'
                      }"
                    >
                      <div
                        style="height: 300px;display: flex;justify-content: center; padding: 80px 0px;"
                      >
                        <span
                          v-if="pictureUrlPreview === ''"
                          class="placeholder img-reward"
                        >
                          <v-img
                            class="v-img-margits"
                            :src="require('@/assets/icons8-add-image-96.png')"
                          ></v-img>
                        </span>
                      </div>

                      <input
                        style="display: none"
                        class="file-input"
                        ref="fileInput"
                        type="file"
                        @input="onSelectFile"
                      />
                    </v-card>
                  </v-col> -->
                  <v-col
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:5px auto; align: center;"
                    justify="center"
                    ><v-card
                      @click="$refs.filePickerField.click()"
                      class="image-input mx-auto"
                      :style="{
                        'background-image': `url(${pictureUrlPreview})`,
                        'background-size': 'contain',
                        'background-position': 'center center',
                        'background-repeat': 'no-repeat',
                        'background-color': '#E8EBF4'
                      }"
                    >
                      <div
                        style="height: 300px;display: flex;justify-content: center; padding: 80px 0px;"
                      >
                        <span
                          v-if="pictureUrlPreview === ''"
                          class="placeholder img-reward"
                        >
                          <v-img
                            class="v-img-margits"
                            :src="require('@/assets/icons8-add-image-96.png')"
                          ></v-img>
                        </span>
                      </div>

                      <input
                        ref="filePickerField"
                        type="file"
                        accept="image/*"
                        @change="launchCropper"
                        hidden
                        style="display: none"
                        class="file-input"
                      />

                      <image-cropper-dialog
                        ref="cropperDialog"
                        :chosenImage="chosenImage"
                        @onReset="$refs.filePickerField.value = null"
                        @onCrop="
                          croppedImage => {
                            pictureUrlPreview = croppedImage
                          }
                        "
                      />
                    </v-card>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="text-align: center"
                  >
                    <v-spacer></v-spacer>
                    <p>ขนาดรูปที่แนะนำ 400 x 400 pixel</p>
                    <v-spacer></v-spacer>
                  </v-col>
                  <!-- <v-col
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:5px auto; text-align: center;"
                    justify="center"
                  >
                    <input
                      ref="filePickerField"
                      type="file"
                      accept="image/*"
                      @change="launchCropper"
                      hidden
                      style="display: none"
                      class="file-input"
                    />
                    <v-card
                      @click="chooseImage"
                      class="image-input"
                      :style="{
                        'background-image': `url(${avatarImage})`,
                        'background-size': 'contain',
                        'background-position': 'center center',
                        'background-repeat': 'no-repeat',
                        'background-color': '#E8EBF4'
                      }"
                    >
                      <div
                        style="height: 300px;display: flex;justify-content: center; padding: 80px 0px;"
                      >
                        <span
                          v-if="avatarImage === ''"
                          class="placeholder img-reward"
                        >
                          <v-img
                            class="v-img-margits"
                            :src="require('@/assets/icons8-add-image-96.png')"
                          ></v-img>
                        </span>
                      </div>
                    </v-card>

                    <div>
                      <v-avatar
                        size="350px"
                        class="mt-5"
                        style="border: 2px solid black;"
                      >
                        <v-img :src="avatarImage"></v-img>
                      </v-avatar>
                    </div>

                    <v-btn class="mt-5" @click="$refs.filePickerField.click()">
                      Upload
                    </v-btn>

                    <image-cropper-dialog
                      ref="cropperDialog"
                      :chosenImage="chosenImage"
                      @onReset="$refs.filePickerField.value = null"
                      @onCrop="
                        croppedImage => {
                          avatarImage = croppedImage
                        }
                      "
                    />
                  </v-col> -->
                </v-row>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" style="">
                <v-row>
                  <!-- <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">ชื่อของรางวัล</p>
                  </v-col> -->
                  <v-col
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-text-field
                      v-model="formAdd.name"
                      label="ชื่อของรางวัล"
                      outlined
                      dense
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-text-field
                      v-model="formAdd.subName"
                      label="ชื่อรองของรางวัล"
                      outlined
                      dense
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-text-field
                      v-model="formAdd.point"
                      label="คะแนนที่ใช้"
                      type="number"
                      min="0"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-select
                      v-model="formAdd.levelId"
                      label="ระดับลูกค้าที่สามารถแลกได้"
                      placeholder="กรุณาเลือก"
                      :items="dataLevel"
                      outlined
                      dense
                      attach
                      :menu-props="{ bottom: true, offsetY: true }"
                      :rules="[rules.required]"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-textarea
                      v-model="formAdd.description"
                      auto-grow
                      rows="2"
                      name="input-7-4"
                      placeholder="รายละเอียด"
                      label="รายละเอียด"
                      outlined
                      dense
                      :rules="[rules.required]"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">
                      ชนิดของรางวัล
                    </p>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 10px"
                  >
                    <v-radio-group v-model="formAdd.supply" row>
                      <v-radio
                        label="รับหน้าร้าน"
                        value="รับหน้าร้าน"
                        color="#6683d3"
                      ></v-radio>
                      <v-radio
                        label="จัดส่งของรางวัล"
                        value="จัดส่ง"
                        color="#6683d3"
                      ></v-radio>
                      <v-radio
                        label="คูปองส่วนลด"
                        value="link_code"
                        color="#6683d3"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row
                  v-if="
                    formAdd.supply === 'รับหน้าร้าน' ||
                      formAdd.supply === 'จัดส่ง'
                  "
                >
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">
                      จำนวนของรางวัล
                    </p>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 10px"
                  >
                    <v-radio-group v-model="formAdd.limitType" row>
                      <v-radio
                        label="ไม่จำกัดจำนวน"
                        value="ไม่จำกัดจำนวน"
                        color="#6683d3"
                      ></v-radio>
                      <v-radio
                        label="จำกัดจำนวน"
                        value="จำกัดจำนวน"
                        color="#6683d3"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row
                  v-if="
                    (formAdd.supply === 'รับหน้าร้าน' ||
                      formAdd.supply === 'จัดส่ง') &&
                      formAdd.limitType === 'จำกัดจำนวน'
                  "
                >
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-text-field
                      v-model="formAdd.count"
                      label="จำนวนที่จำกัด"
                      type="number"
                      min="0"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">
                      ประเภทวันหมดอายุ
                    </p>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 10px"
                  >
                    <v-radio-group v-model="formAdd.expireType" row>
                      <v-radio
                        label="กำหนดวันหมดอายุ"
                        value="FixDate"
                        color="#6683d3"
                      ></v-radio>
                      <v-radio
                        label="หมดอายุหลังจากวันที่แลกของรางวัล"
                        value="Redeem"
                        color="#6683d3"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row v-if="formAdd.expireType === 'FixDate'">
                  <!-- <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">
                      วันหมดอายุ
                    </p>
                  </v-col> -->
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="6"
                    lg="6"
                    style="padding: 0px 0px !important"
                  >
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="formAdd.startDate"
                          readonly
                          label="วันที่เริ่มต้นหมดอายุ"
                          outlined
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="formAdd.startDate"
                        @input="menu1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="6"
                    lg="6"
                    style="padding: 0px 0px !important"
                  >
                    <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="formAdd.endDate"
                          readonly
                          label="วันที่สิ้นสุดหมดอายุ"
                          outlined
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="formAdd.endDate"
                        @input="menu2 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row v-if="formAdd.expireType === 'Redeem'">
                  <!-- <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">
                      หมดอายุนับจากวันที่แลกของรางวัล
                    </p>
                  </v-col> -->
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-text-field
                      v-model="formAdd.countExpire"
                      label="หมดอายุนับจากวันที่แลกของรางวัล"
                      type="number"
                      min="0"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">
                      ประเภทการแสดง
                    </p>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="6"
                    sm="6"
                    md="6"
                    lg="6"
                    style="padding:0px 15px 0px"
                  >
                    <v-checkbox
                      v-model="formAdd.trending"
                      label="รางวัลยอดฮิตในสัปดาห์นี้"
                    ></v-checkbox>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="6"
                    sm="6"
                    md="6"
                    lg="6"
                    style="padding:0px 15px 0px"
                  >
                    <v-checkbox
                      v-model="formAdd.specialOffer"
                      label="รางวัลสุดพิเศษ"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row v-if="addReward.supply === 'link_code'">
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">นำเข้าข้อมูลจำนวนของรางวัล</p>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="7"
                    md="7"
                    lg="7"
                    style="padding:5px 15px 0px"
                  >
                    <input
                      type="file"
                      @change="importData"
                      accept=".xls,.xlsx"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="5"
                    md="5"
                    lg="5"
                    style="padding:0px 0px"
                  >
                    <v-btn class="btn-color">
                      <v-icon color="white" left>mdi-download</v-icon>
                      <download-excel
                        class="btn btn-default"
                        :data="export_data"
                        :fields="export_fields"
                        :type="exportType"
                        :worksheet="exportWorksheet"
                        :name="exportFileName"
                      >
                        รูปแบบนำเข้าข้อมูล
                      </download-excel>
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="5"
                    md="5"
                    lg="5"
                    style="padding:0px 0px"
                  >
                    <template>
                      <v-data-table
                        :headers="columnsImport"
                        :items="dataItemImport"
                        :items-per-page="5"
                        :sort-by="['status']"
                        :sort-desc="[true]"
                      >
                        <template v-slot:[`item.status`]="{ item }">
                          <v-chip
                            color="red"
                            outlined
                            v-if="item.status === 'False'"
                            >False</v-chip
                          >
                          <v-chip
                            color="green"
                            outlined
                            v-if="item.status === 'True'"
                            >True</v-chip
                          >
                        </template>
                      </v-data-table>
                    </template>
                  </v-col>
                </v-row>
                <v-row style="padding-bottom: 8%">
                  <v-col style="padding-top:20px">
                    <!-- ,
                          (formAddData = false),
                          (showData = true) -->
                    <v-btn
                      block
                      large
                      color="primary"
                      dark
                      @click="validate(), addData()"
                      >บันทึก</v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
        <!-- end -->

        <!-- update Data reward -->
        <v-container
          style="padding: 0px 15px;
            overflow-y:hidden"
        >
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            v-if="formUpdateData"
          >
            <v-row style="padding-top: 20px;">
              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="6"
                lg="6"
                style="background-color:"
              >
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">รูปของรางวัล</p>
                  </v-col>
                  <v-col
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:5px auto; text-align: center;"
                    justify="center"
                    ><v-card
                      @click="chooseImage"
                      class="image-input"
                      :style="{
                        'background-image': `url(${pictureUrlPreview})`,
                        'background-size': 'contain',
                        'background-position': 'center center',
                        'background-repeat': 'no-repeat'
                      }"
                    >
                      <div
                        style="height: 300px;display: flex;padding: 0px 126px;
       align-items: center;"
                      >
                        <span
                          v-if="pictureUrlPreview === ''"
                          class="placeholder img-reward"
                        >
                          <v-img
                            class="v-img-margits"
                            :src="require('@/assets/icons8-add-image-96.png')"
                          ></v-img>
                        </span>
                      </div>

                      <input
                        style="display: none"
                        class="file-input"
                        ref="fileInput"
                        type="file"
                        @input="onSelectFileUpdate"
                      />
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" style="">
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">ชื่อของรางวัล</p>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-text-field
                      v-model="formUpdate.name"
                      label="ชื่อของรางวัล"
                      solo
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    class="text-field-no-one"
                  >
                    <p style="margin: 0px 0px">ชื่อรองของรางวัล</p>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-text-field
                      v-model="formUpdate.subName"
                      label="ชื่อรองของรางวัล"
                      solo
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">คะแนนที่ใช้</p>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-text-field
                      v-model="formUpdate.point"
                      label="คะแนนที่ใช้"
                      type="number"
                      min="0"
                      solo
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">
                      ระดับของลูกค้า ที่สามารถแลกได้
                    </p>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-select
                      v-model="formUpdate.levelId"
                      label="กรูณาเลือก"
                      :items="dataLevel"
                      solo
                      attach
                      :menu-props="{ bottom: true, offsetY: true }"
                      :rules="[rules.required]"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">
                      เงื่อนไข/รายละเอียดของรางวัล
                    </p>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-textarea
                      v-model="formUpdate.description"
                      auto-grow
                      rows="2"
                      name="input-7-4"
                      placeholder="รายละเอียด"
                      label="รายละเอียด"
                      solo
                      :rules="[rules.required]"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">
                      ชนิดของรางวัล
                    </p>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 10px"
                  >
                    <v-radio-group v-model="formUpdate.supply" row>
                      <v-radio
                        label="รับหน้าร้าน"
                        value="รับหน้าร้าน"
                        color="#6683d3"
                        disabled
                      ></v-radio>
                      <v-radio
                        label="จัดส่งของรางวัล"
                        value="จัดส่ง"
                        color="#6683d3"
                        disabled
                      ></v-radio>
                      <v-radio
                        label="คูปองส่วนลด"
                        value="link_code"
                        color="#6683d3"
                        disabled
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row
                  v-if="
                    formUpdate.supply === 'รับหน้าร้าน' ||
                      formUpdate.supply === 'จัดส่ง'
                  "
                >
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">
                      จำนวนของรางวัล
                    </p>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 10px"
                  >
                    <v-radio-group v-model="formUpdate.limitType" row>
                      <v-radio
                        label="ไม่จำกัดจำนวน"
                        value="ไม่จำกัดจำนวน"
                        color="#6683d3"
                        disabled
                      ></v-radio>
                      <v-radio
                        label="จำกัดจำนวน"
                        value="จำกัดจำนวน"
                        color="#6683d3"
                        disabled
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row
                  v-if="
                    (formUpdate.supply === 'รับหน้าร้าน' ||
                      formUpdate.supply === 'จัดส่ง') &&
                      formUpdate.limitType === 'จำกัดจำนวน'
                  "
                >
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">
                      จำนวนที่จำกัด
                    </p>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-text-field
                      v-model="formUpdate.count"
                      label="จำนวนที่จำกัด"
                      type="number"
                      min="0"
                      solo
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">
                      ประเภทวันหมดอายุ
                    </p>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 10px"
                  >
                    <v-radio-group v-model="formUpdate.expireType" row>
                      <v-radio
                        label="กำหนดวันหมดอายุ"
                        value="FixDate"
                        color="#6683d3"
                        disabled
                      ></v-radio>
                      <v-radio
                        label="หมดอายุหลังจากวันที่แลกของรางวัล"
                        value="Redeem"
                        color="#6683d3"
                        disabled
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row v-if="formUpdate.expireType === 'FixDate'">
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">
                      วันหมดอายุ
                    </p>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="6"
                    lg="6"
                    style="padding: 0px 0px !important"
                  >
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="formUpdate.startDate"
                          readonly
                          prepend-inner-icon="mdi-calendar"
                          label="วันเริ่มต้น"
                          solo
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="formUpdate.startDate"
                        @input="menu1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="6"
                    lg="6"
                    style="padding: 0px 0px !important"
                  >
                    <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="formUpdate.endDate"
                          readonly
                          prepend-inner-icon="mdi-calendar"
                          label="วันสิ้นสุด"
                          solo
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="formUpdate.endDate"
                        @input="menu2 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row v-if="formUpdate.expireType === 'Redeem'">
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">
                      หมดอายุนับจากวันที่แลกของรางวัล
                    </p>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:0px 0px"
                  >
                    <v-text-field
                      v-model="formUpdate.countExpire"
                      label="หมดอายุนับจากวันที่แลกของรางวัล"
                      type="number"
                      min="0"
                      solo
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="formUpdate.supply === 'link_code'">
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">นำเข้าข้อมูลจำนวนของรางวัล</p>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="7"
                    md="7"
                    lg="7"
                    style="padding:5px 15px 0px"
                  >
                    <input
                      type="file"
                      @change="importData"
                      accept=".xls,.xlsx"
                    />
                  </v-col>
                  <v-col xs="12" sm="5" md="5" lg="5" style="padding:0px 0px">
                    <v-btn class="btn-color">
                      <v-icon color="white" left>mdi-download</v-icon>
                      <download-excel
                        class="btn btn-default"
                        :data="export_data"
                        :fields="export_fields"
                        :type="exportType"
                        :worksheet="exportWorksheet"
                        :name="exportFileName"
                      >
                        รูปแบบนำเข้าข้อมูล
                      </download-excel>
                    </v-btn>
                  </v-col>
                  <v-col xs="12" sm="5" md="5" lg="5" style="padding:0px 0px">
                    <template>
                      <v-data-table
                        :headers="columnsImport"
                        :items="dataItemImport"
                        :items-per-page="5"
                        :sort-by="['status']"
                        :sort-desc="[true]"
                      >
                        <template v-slot:[`item.status`]="{ item }">
                          <v-chip
                            color="red"
                            outlined
                            v-if="item.status === 'False'"
                            >False</v-chip
                          >
                          <v-chip
                            color="green"
                            outlined
                            v-if="item.status === 'True'"
                            >True</v-chip
                          >
                        </template>
                      </v-data-table>
                    </template>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding:12px 15px 0px"
                  >
                    <p style="margin: 0px 0px">
                      ประเภทการแสดง
                    </p>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="6"
                    sm="6"
                    md="6"
                    lg="6"
                    style="padding:0px 15px 0px"
                  >
                    <v-checkbox
                      v-model="formUpdate.trending"
                      label="รางวัลยอดฮิตในสัปดาห์นี้"
                    ></v-checkbox>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="6"
                    sm="6"
                    md="6"
                    lg="6"
                    style="padding:0px 15px 0px"
                  >
                    <v-checkbox
                      v-model="formUpdate.specialOffer"
                      label="รางวัลสุดพิเศษ"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row style="padding-bottom: 8%">
                  <v-col style="padding-top:20px">
                    <v-btn
                      block
                      large
                      color="primary"
                      @click="validate(), editData(), (showData = true)"
                      >บันทึก</v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
        <!-- end -->

        <!-- show Data reward -->
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          v-if="showData"
          style="overflow: hidden"
        >
          <v-row style="">
            <v-col
              cols="12"
              xs="12"
              sm="6"
              md="3"
              lg="3"
              v-for="n in updateReward"
              :key="n.rewardId"
              style="margin:  0px 0px;"
            >
              <v-container style="padding: 12px 12px 12px 12px">
                <v-card
                  class="mx-auto"
                  max-width="374"
                  style="min-height: 440px;"
                >
                  <v-img height="200" :src="n.pictureUrl"></v-img>

                  <v-card-title style="padding: 12px 9px 14px">{{
                    n.name.length > 30 ? n.name.substr(0, 30) + '...' : n.name
                  }}</v-card-title>

                  <v-card-text style="padding: 0px 9px">
                    <v-row>
                      <v-col style="padding: 5px 9px">
                        <p style="margin: 0px 9px">คะแนนที่ใช้</p>
                      </v-col>
                      <v-col
                        class="text-right"
                        style="padding: 5px 15px;margin-right:10px"
                      >
                        <p style="margin: 0px 0px">{{ n.point }} คะแนน</p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col style="padding: 5px 9px">
                        <p style="margin: 0px 9px">จำนวนคงเหลือ</p>
                      </v-col>
                      <v-col
                        class="text-right"
                        style="padding: 5px 15px;margin-right:10px"
                      >
                        <p style="margin: 0px 0px">
                          {{
                            n.quotaCode != 0 && n.limitType == 'จำกัดจำนวน'
                              ? n.quotaCode + ' ชิ้น'
                              : n.quotaCode == 0 &&
                                n.limitType == 'ไม่จำกัดจำนวน'
                              ? 'ไม่จำกัดจำนวน'
                              : n.quotaCode == 0 && n.limitType == 'จำกัดจำนวน'
                              ? 'หมด'
                              : null
                          }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col style="padding: 5px 9px" md="6">
                        <p style="margin: 0px 9px">
                          ประเภทรางวัล
                        </p>
                      </v-col>
                      <v-col
                        v-if="n.supply === 'link_code'"
                        class="text-right"
                        style="padding: 5px;margin-right:10px"
                      >
                        <v-chip color="#4bd620" dark
                          ><v-icon>mdi-ticket-confirmation</v-icon
                          ><span> </span> คูปอง</v-chip
                        >
                      </v-col>
                      <v-col
                        v-if="n.supply === 'จัดส่ง'"
                        class="text-right"
                        style="padding: 5px;margin-right:10px"
                      >
                        <v-chip color="#f59c27" dark
                          ><v-icon>mdi-truck</v-icon
                          ><span> </span> จัดส่ง</v-chip
                        >
                      </v-col>
                      <v-col
                        v-if="n.supply === 'รับหน้าร้าน'"
                        class="text-right"
                        style="padding: 5px;margin-right:10px"
                      >
                        <v-chip color="#2795f5" dark
                          ><v-icon>mdi-home</v-icon
                          ><span> </span> รับหน้าร้าน</v-chip
                        >
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-divider style="margin-top:20px"></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-chip
                      color="#4548f7"
                      dark
                      @click="
                        ;(formUpdateData = true),
                          (showData = false),
                          getDataById(n)
                      "
                    >
                      <v-icon>
                        mdi-pencil
                      </v-icon>
                    </v-chip>
                    <v-chip
                      color="#f74569"
                      dark
                      @click="getDataById(n, 'delete')"
                    >
                      <v-icon>
                        mdi-delete
                      </v-icon>
                    </v-chip>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-col>
          </v-row>
        </v-form>
        <!-- end -->
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import moment from 'moment' // แปลง date
import ImageCropperDialog from './ImageCropperDialog.vue'
export default {
  name: 'home',
  components: {
    XLSX,
    readXlsxFile,
    downloadExcel: JsonExcel,
    moment,
    ImageCropperDialog
  },
  data () {
    return {
      path: '/reward/',
      returnLink: '/Master/Reward',
      session: this.$session.getAll(),
      formAddData: false,
      formUpdateData: false,
      showData: true,
      valid: true,
      dataLevel: [],
      dataItemImport: [],
      columnsImport: [
        { text: 'Reward Code', value: 'rewardCode' },
        { text: 'Status', value: 'status', sortable: false }
      ],
      menu1: false,
      menu2: false,
      date: [],
      dates: new Date().toISOString().slice(0, 10),
      title: ['คะแนนที่ใช้', 'จำนวนคงเหลือ', 'ประเภทของรางวัล'],
      formAdd: {
        pictureUrl: '',
        name: '',
        subName: '',
        point: '',
        levelId: 'allLevel',
        description: '',
        supply: 'รับหน้าร้าน',
        limitType: 'ไม่จำกัดจำนวน',
        count: '',
        expireType: 'FixDate',
        startDate: '',
        endDate: '',
        countExpire: '',
        trending: false,
        specialOffer: false,
        shopId: this.$session.getAll().data.shopId,
        CREATE_USER: '',
        LAST_USER: ''
      },
      reward: {
        pictureUrl: '',
        name: '',
        subName: '',
        point: '',
        levelId: '',
        description: '',
        supply: '',
        limitType: '',
        expireTypeReward: '',
        startDateReward: null,
        endDateReward: null,
        countExpireReward: 0,
        trending: '',
        specialOffer: '',
        shopId: this.$session.getAll().data.shopId,
        CREATE_USER: '',
        LAST_USER: ''
      },
      rewardCode: {
        rewardId: '',
        rewardCode: '',
        prefix: '',
        count: '',
        expireType: '',
        countExpire: '',
        openDate: '',
        genType: '',
        // useDate: '',
        startDate: '',
        endDate: '',
        redeemStatus: '',
        shopId: this.$session.getAll().data.shopId,
        CREATE_USER: '',
        LAST_USER: ''
      },
      formUpdate: {
        rewardId: '',
        pictureUrl: '',
        name: '',
        subName: '',
        point: '',
        levelId: '',
        description: '',
        supply: '',
        limitType: '',
        countExpire: 0,
        startDate: null,
        endDate: null,
        count: '',
        trending: '',
        specialOffer: '',
        shopId: this.$session.getAll().data.shopId,
        CREATE_USER: '',
        AST_USER: ''
      },
      updateRewards: {
        rewardId: '',
        pictureUrl: '',
        name: '',
        subName: '',
        point: '',
        levelId: '',
        description: '',
        supply: '',
        limitType: '',
        expireTypeReward: '',
        startDateReward: null,
        endDateReward: null,
        countExpireReward: 0,
        trending: '',
        specialOffer: '',
        shopId: this.$session.getAll().data.shopId,
        CREATE_USER: '',
        LAST_USER: ''
      },
      updateRewardCode: {
        rewardId: '',
        rewardCode: '',
        prefix: '',
        count: '',
        expireType: '',
        countExpire: '',
        openDate: '',
        genType: '',
        startDate: '',
        endDate: '',
        redeemStatus: '',
        shopId: this.$session.getAll().data.shopId,
        CREATE_USER: '',
        LAST_USER: ''
      },
      //   formUpdate: {
      //     rewardId: '',
      //     pictureUrl: '',
      //     name: '',
      //     subName: '',
      //     point: '',
      //     levelId: '',
      //     description: '',
      //     supply: '',
      //     limitType: '',
      //     countExpire: '',
      //     count: '',
      //     startDate: null,
      //     endDate: null,
      //     trending: '',
      //     most: '',
      //     specialOffer: '',
      //     shopId: this.$session.getAll().data.shopId,
      //     CREATE_USER: '',
      //     LAST_USER: '',
      //     updateDate: []
      //   },
      addReward: {
        pictureUrl: '',
        name: '',
        subName: '',
        point: '',
        levelId: 'allLevel',
        description: '',
        supply: 'รับหน้าร้าน',
        limitType: 'ไม่จำกัดจำนวน',
        expireTypeReward: '',
        countExpireReward: 0,
        startDateReward: null,
        endDateReward: null,
        trending: 'False',
        most: 'False',
        specialOffer: 'False',
        shopId: this.$session.getAll().data.shopId,
        CREATE_USER: '',
        LAST_USER: ''
      },
      addRewardCode: {
        rewardId: '',
        rewardCode: '',
        prefix: '',
        count: 0,
        expireType: 'FixDate',
        countExpire: 0,
        startDate: '',
        endDate: '',
        redeemStatus: '',
        shopId: this.$session.getAll().data.shopId,

        CREATE_USER: '',
        LAST_USER: '',

        genType: '',

        exprieDate: ''
      },
      updateRew: {
        rewardId: '',
        pictureUrl: '',
        name: '',
        subName: '',
        point: '',
        levelId: '',
        description: '',
        supply: '',
        limitType: '',
        expireTypeReward: '',
        countExpireReward: '',
        startDateReward: null,
        endDateReward: null,
        exprieDate: '',
        trending: '',
        most: '',
        specialOffer: '',
        shopId: this.$session.getAll().data.shopId,
        CREATE_USER: '',
        LAST_USER: ''
      },
      formUpdateCod: {
        prefix: '',
        rewardCode: '',
        count: '',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: this.$session.getAll().data.shopId,
        rewardId: '',
        startDate: '',
        endDate: '',
        expireType: '',
        countExpire: '',
        genType: '',
        redeemStatus: '',
        exprieDate: ''
      },
      Img: '',
      exportType: 'xls',
      exportFileName: 'รูปแบบการนำเข้าข้อมูล.xls',
      exportWorksheet: 'WorkSheet',
      export_fields: {
        rewardCode: 'rewardCode'
      },
      export_data: [
        {
          rewardCode: 'กรอก Code'
        }
      ],
      pictureUrlPreview: '',
      rules: {
        required: value => !!value || 'กรุณากรอก.'
      },
      filesAdd: null,
      nameSort: '',
      updateReward: [],
      avatarImage: '',
      chosenImage: null
    }
  },
  created: {
    isMobile () {
      if (screen.width <= 760) {
        return true
      } else {
        return false
      }
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    await this.getDataLevel(
      this.DNS_IP,
      this.session.data.shopId,
      this.returnLink
    )
    await this.getDataReward()
  },
  methods: {
    async launchCropper (event) {
      if (!event) return
      var file = event.target.files[0]
      console.log('file', file)
      this.chosenImage = await this.toBase64(file)
      console.log(this.chosenImage)
      this.$refs.cropperDialog.initCropper(file.type)
    },
    async toBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    validate () {
      this.$refs.form.validate()
    },
    async getDataLevel (DNS_IP, shopId, returnLink) {
      this.dataLevel = []
      await axios
        .get(DNS_IP + '/level/get?shopId=' + shopId)
        .then(async response => {
          console.log('getDataLevel', response.data)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            d.text = d.name
            d.value = d.levelId.toString()
            this.dataLevel.push(d)
          }
          this.dataLevel.push({
            text: 'ไม่จำกัด',
            value: 'allLevel',
            levelId: 'allLevel'
          })
          console.log(this.dataLevel)
        })
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + returnLink)
          this.dataReady = true
        })
    },
    chooseImage () {
      this.$refs.fileInput.click()
    },
    onSelectFile () {
      const input = this.$refs.fileInput
      this.filesAdd = input.files
      if (this.filesAdd) {
        this.pictureUrlPreview = URL.createObjectURL(this.filesAdd[0])
        this.formAdd.pictureUrl = this.pictureUrlPreview
      } else {
        this.pictureUrlPreview = ''
      }
      //   this.$forceUpdate()
    },
    async getDataById (item, type) {
      this.dataReady = false
      await this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'rewardId',
        item.rewardId,
        this.returnLink
      )
      if (this.formUpdate.limitType === 'ไม่จำกัดจำนวน') {
        this.formUpdate.expireType = this.formUpdate.expireTypeReward
        if (this.formUpdate.expireType === 'Redeem') {
          this.formUpdate.countExpire = this.formUpdate.countExpireReward
        } else {
          this.formUpdate.startDate = moment(
            String(this.formUpdate.startDateReward)
          ).format('YYYY-MM-DD')
          this.formUpdate.endDate = moment(
            String(this.formUpdate.endDateReward)
          ).format('YYYY-MM-DD')
        }
      } else {
        if (this.formUpdate.expireType === 'Redeem') {
          this.formUpdate.countExpire = this.formUpdate.countExpireCode
        } else {
          this.formUpdate.startDate = moment(
            String(this.formUpdate.startDateCode)
          ).format('YYYY-MM-DD')
          this.formUpdate.endDate = moment(
            String(this.formUpdate.endDateCode)
          ).format('YYYY-MM-DD')
        }
      }
      this.formUpdate.count = this.formUpdate.quotaCode
      this.formUpdate.pictureUrl = this.formUpdate.pictureUrl
      this.pictureUrlPreview = this.formUpdate.pictureUrl

      if (type === 'delete') {
        this.deleteData()
      }
    },
    async addData () {
      if (this.$refs.form.validate() === true) {
        //* **  start reward **********
        this.reward.pictureUrl = this.formAdd.pictureUrl
        this.reward.name = this.formAdd.name
        this.reward.subName = this.formAdd.subName
        this.reward.point = this.formAdd.point
        this.reward.levelId = this.formAdd.levelId
        this.reward.description = this.formAdd.description
        this.reward.supply = this.formAdd.supply
        this.reward.limitType = this.formAdd.limitType
        this.reward.expireTypeReward = this.formAdd.expireType
        if (this.reward.limitType === 'ไม่จำกัดจำนวน') {
          if (this.formAdd.expireType === 'FixDate') {
            this.reward.startDateReward = this.formAdd.startDate
            this.reward.endDateReward = this.formAdd.endDate
            this.reward.countExpireReward = 0
          } else {
            this.reward.startDateReward = null
            this.reward.endDateReward = null
            this.reward.countExpireReward = this.formAdd.countExpire
          }
        } else {
          this.reward.startDateReward = null
          this.reward.endDateReward = null
          this.reward.countExpireReward = 0
        }
        this.reward.CREATE_USER = this.session.data.userName
        this.reward.LAST_USER = this.session.data.userName
        // ******  end  *****
        console.log(this.reward)
        // this.reward.pictureUrl = URL.createObjectURL(this.filesAdd[0])
        this.filesAdd = this.pictureUrlPreview
        let blob = this.dataURItoBlob(this.filesAdd)
        let pic = this.blobToFile(blob, 'my-image.png')
        // console.log('this.filesAdd', pic)
        const _this = this
        let params = new FormData()
        params.append('file', pic)
        await axios
          .post(this.DNS_IP + `/file/upload/reward`, params)
          .then(response => {
            _this.reward.pictureUrl = response.data
          })
        console.log('this.reward', this.reward)
        await axios
          .post(this.DNS_IP + '/reward/add', this.reward)
          .then(async response => {
            console.log('addDataGlobal DNS_IP + PATH + "add"', response)

            this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          })

          .catch(error => {
            console.log('error function addDataGlobal : ', error)
            this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
          })
        if (this.formAdd.limitType === 'จำกัดจำนวน') {
          this.addDataRewardCode()
          this.formAddData = false
        }
      }
    },
    dataURItoBlob (dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
      var byteString = atob(dataURI.split(',')[1])

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      // write the bytes of the string to an ArrayBuffer
      var ab = new ArrayBuffer(byteString.length)
      var ia = new Uint8Array(ab)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      // Old Code
      // write the ArrayBuffer to a blob, and you're done
      // var bb = new BlobBuilder();
      // bb.append(ab);
      // return bb.getBlob(mimeString);

      // New Code
      return new Blob([ab], {type: mimeString})
    },
    blobToFile (theBlob, fileName) {
    // A Blob() is almost a File() - it's just missing the two properties below which we will add
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    async addDataRewardCode () {
      if (this.formAdd.limitType === 'จำกัดจำนวน') {
        await axios
          .get(
            this.DNS_IP +
              '/reward/get?shopId=' +
              this.session.data.shopId +
              '&name=' +
              this.formAdd.name
          )
          .then(async result => {
            let re = result.data
            this.rewardCode.rewardId = re[0].rewardId
            this.rewardCode.prefix = Date.now()
              .toString()
              .substr(9, 13)
            this.rewardCode.count = this.formAdd.count
            if (this.formAdd.limitType === 'จำกัดจำนวน') {
              if (this.formAdd.expireType === 'FixDate') {
                this.rewardCode.startDate = this.formAdd.startDate
                this.rewardCode.endDate = this.formAdd.endDate
                this.rewardCode.countExpire = 0
              } else {
                this.rewardCode.startDate = null
                this.rewardCode.endDate = null
                this.rewardCode.countExpire = this.formAdd.countExpire
              }
            } else {
              this.rewardCode.startDate = null
              this.rewardCode.endDate = null
              this.rewardCode.countExpire = 0
            }
            this.rewardCode.expireType = this.formAdd.expireType
            this.rewardCode.genType = 'gen'
            this.rewardCode.CREATE_USER = this.session.data.userName
            this.rewardCode.LAST_USER = this.session.data.userName
            this.rewardCode.redeemStatus = 'open'
            console.log('this.rewardCode', this.rewardCode)
            await axios
              .post(this.DNS_IP + '/rewardCode/add', this.rewardCode)
              .then(async response => {
                if (response.data.status === true) {
                  console.log('response.data.status :', response.data.status)
                }
                await this.getDataReward()
              })
              .catch(error => {
                console.log('error function addDataGlobal : ', error)
                this.$router.push(
                  '/system/Errorpage?returnLink=' + this.returnLink
                )
              })
          })
      }
      await this.getDataReward()
    },
    async editData () {
      if (
        this.formUpdate.count > this.formUpdate.defultQuotaCode ||
        this.formUpdate.count === this.formUpdate.defultQuotaCode
      ) {
        this.$swal('สำเร็จ', 'บันทึกข้อมูลเรียบร้อย', 'success').then(
          async result => {
            if (this.filesAdd) {
              const _this = this
              let params = new FormData()
              params.append('file', this.filesAdd[0])
              await axios
                .post(this.DNS_IP + `/file/upload/reward`, params)
                .then(function (response) {
                  _this.formUpdate.pictureUrl = response.data
                  console.log('url Pic', response.data)
                })
            } else {
              this.formUpdate.pictureUrl = this.pictureUrlPreview
            }
            this.updateRewards.rewardId = this.formUpdate.rewardId
            this.updateRewards.pictureUrl = this.formUpdate.pictureUrl
            this.updateRewards.name = this.formUpdate.name
            this.updateRewards.subName = this.formUpdate.subName
            this.updateRewards.point = this.formUpdate.point
            this.updateRewards.levelId = this.formUpdate.levelId
            this.updateRewards.description = this.formUpdate.description
            this.updateRewards.supply = this.formUpdate.supply
            this.updateRewards.limitType = this.formUpdate.limitType
            this.updateRewards.expireTypeReward = this.formUpdate.expireType
            this.updateRewards.startDateReward = this.formUpdate.startDate
            this.updateRewards.endDateReward = this.formUpdate.endDate
            this.updateRewards.countExpireReward = this.formUpdate.countExpire
            this.updateRewards.trending = this.formUpdate.trending
            this.updateRewards.specialOffer = this.formUpdate.specialOffer
            console.log('this.updateReward', this.updateRewards.rewardId)
            await axios
              .post(
                this.DNS_IP + '/reward/edit/' + this.updateRewards.rewardId,
                this.updateRewards
              )
              .then(async response => {
                // Debug response
                console.log('addDataGlobal DNS_IP + PATH + "add"', response)

                // this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              })
            if (this.formUpdate.limitType === 'จำกัดจำนวน') {
              this.editRewardCode()
            }
            this.getDataReward()
            this.formUpdateData = false
          }
        )
      } else if (this.formUpdate.count < this.formUpdate.quotaCode) {
        this.$swal('ไม่สำเร็จ', 'จำนวนของรางวัลน้อยกว่าจำนวนปัจจุบัน', 'error')
      }
    },
    async editRewardCode () {
      if (this.formUpdate.limitType === 'จำกัดจำนวน') {
        if (this.formUpdate.defultQuotaCode < this.formUpdate.count) {
          await axios
            .get(
              this.DNS_IP +
                '/reward/get?shopId=' +
                this.session.data.shopId +
                '&name=' +
                this.formUpdate.name
            )
            .then(async result => {
              let re = result.data
              this.updateRewardCode.rewardId = re[0].rewardId
              this.updateRewardCode.prefix = Date.now()
                .toString()
                .substr(9, 13)
              this.updateRewardCode.count =
                this.formUpdate.count - this.formUpdate.defultQuotaCode
              if (this.formUpdate.limitType === 'จำกัดจำนวน') {
                if (this.formUpdate.expireType === 'FixDate') {
                  this.updateRewardCode.startDate = this.formUpdate.startDate
                  this.updateRewardCode.endDate = this.formUpdate.endDate
                  this.updateRewardCode.countExpire = 0
                } else {
                  this.updateRewardCode.startDate = null
                  this.updateRewardCode.endDate = null
                  this.updateRewardCode.countExpire = this.formUpdate.countExpire
                }
              } else {
                this.updateRewardCode.startDate = null
                this.updateRewardCode.endDate = null
                this.updateRewardCode.countExpire = 0
              }
              this.updateRewardCode.expireType = this.formUpdate.expireType
              this.updateRewardCode.genType = 'gen'
              this.updateRewardCode.CREATE_USER = this.session.data.userName
              this.updateRewardCode.LAST_USER = this.session.data.userName
              this.updateRewardCode.redeemStatus = 'open'
              console.log('this.rewardCode', this.updateRewardCode)
              await axios
                .post(this.DNS_IP + '/rewardCode/add', this.updateRewardCode)
                .then(async response => {
                  if (response.data.status === true) {
                    console.log('response.data.status :', response.data.status)
                  }
                  await this.getDataReward()
                })
                .catch(error => {
                  console.log('error function addDataGlobal : ', error)
                  this.$router.push(
                    '/system/Errorpage?returnLink=' + this.returnLink
                  )
                })
            })
        } else if (this.formUpdate.defultQuotaCode > this.formUpdate.count) {
          this.$swal(
            'ไม่สำเร็จ',
            'จำนวนของรางวัลน้อยกว่าจำนวนปัจจุบัน',
            'error'
          )
        }
      }
    },

    onSelectFileUpdate () {
      const input = this.$refs.fileInput
      this.filesAdd = input.files
      if (this.filesAdd) {
        this.pictureUrlPreview = URL.createObjectURL(this.filesAdd[0])
        this.formUpdate.pictureUrl = this.pictureUrlPreview
        console.log(this.formUpdate.pictureUrl)
      } else {
        this.pictureUrlPreview = ''
      }
      //   this.$forceUpdate()
    },
    reset () {
      this.$refs.form.reset()
    },
    ImgShow () {
      if (this.Img) {
        this.pictureUrlPreview = URL.createObjectURL(this.Img)
      }
    },
    dateJoin () {
      this.addRewardCode.exprieDate = this.date.join(' ถึง ')
      this.addRewardCode.startDate = this.date[0]
      this.addRewardCode.endDate = this.date[1]
    },

    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        text:
          'คุณแน่ใจที่จะลบ' + ' ' + this.formUpdate.name + ' ' + 'หรือไม่ ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก'
      })
        .then(async result => {
          await axios
            .post(
              this.DNS_IP + this.path + 'delete/' + this.formUpdate.rewardId,
              this.formUpdate
            )
            .then(async response => {
              console.log('DNS_IP + PATH + "delete/"', response)
              this.$swal('เรียบร้อย', 'ลบข้อมูลเรียบร้อย', 'success')
              await this.getDataReward()
            })
            .catch(error => {
              console.log('error function deleteDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch(error => {
          console.log('error function deleteDataGlobal : ', error)
        })
    },
    async addDataa () {
      if (this.addReward.limitType === 'ไม่จำกัดจำนวน') {
        if (this.addRewardCode.expireType === 'FixDate') {
          this.addReward.startDateReward = this.addRewardCode.startDate
          this.addReward.endDateReward = this.addRewardCode.endDate
          delete this.addRewardCode['startDate']
          delete this.addRewardCode['endDate']
        } else {
          this.addReward.startDateReward = null
          this.addReward.endDateReward = null
          this.addReward.countExpireReward = this.addRewardCode.countExpire
          delete this.addRewardCode['countExpire']
        }
      }

      if (
        this.addReward.limitType === 'ไม่จำกัดจำนวน' &&
        this.addRewardCode.expireType === 'FixDate'
      ) {
        this.addReward.expireTypeReward = 'FixDate'
        delete this.addRewardCode['expireType']
      } else if (
        this.addReward.limitType === 'ไม่จำกัดจำนวน' &&
        this.addRewardCode.expireType === 'Redeem'
      ) {
        this.addReward.expireTypeReward = 'Redeem'
        delete this.addRewardCode['expireType']
      }
      //   console.log('addreward', this.addReward)

      this.addReward.CREATE_USER = this.session.data.userName
      this.addReward.LAST_USER = this.session.data.userName
      this.addReward.pictureUrl = URL.createObjectURL(this.filesAdd[0])
      const _this = this
      let params = new FormData()
      params.append('file', this.filesAdd[0])
      await axios
        .post(this.DNS_IP + `/file/upload/reward`, params)
        .then(response => {
          _this.addReward.pictureUrl = response.data
        })
      console.log('addReward', this.addReward)
      await axios
        .post(this.DNS_IP + '/reward/add', this.addReward)
        .then(async response => {
          // Debug response
          console.log('addDataGlobal DNS_IP + PATH + "add"', response)

          this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
        })

        .catch(error => {
          console.log('error function addDataGlobal : ', error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
      if (this.addReward.supply === 'link_code') {
        console.log('link_code')
      } else {
        await this.addQuota()
        await this.getDataReward()
      }
    },
    async addQuota () {
      if (this.addReward.limitType === 'จำกัดจำนวน') {
        // alert('1')
        await axios
          .get(
            this.DNS_IP +
              '/reward/get?shopId=' +
              this.session.data.shopId +
              '&name=' +
              this.addReward.name
          )
          .then(async res => {
            // alert('2')
            this.addRewardCode.rewardId = res.data[0].rewardId
            this.addRewardCode.genType = 'gen'
            this.addRewardCode.CREATE_USER = this.session.data.userName
            this.addRewardCode.LAST_USER = this.session.data.userName
            this.addRewardCode.redeemStatus = 'open'
            if (this.addRewardCode.expireType === 'Redeem') {
              this.addRewardCode.startDate = ''
              this.addRewardCode.endDate = ''
            }
            this.addRewardCode.prefix = res.data[0].name.substr(0, 5)
            await axios
              .post(this.DNS_IP + '/rewardCode/add', this.addRewardCode)
              .then(async response => {
                if (response.data.status === false) {
                  console.log('response.data.status :', response.data.status)
                }
              })
              .catch(error => {
                console.log('error function addDataGlobal : ', error)
                this.$router.push(
                  '/system/Errorpage?returnLink=' + this.returnLink
                )
              })
          })
      }
      this.clearData()
      this.reset()
      this.formAddData = false
    },
    // async editDataa () {
    //   //   alert('edit')
    //   this.$swal({
    //     title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
    //     type: 'question',
    //     showCancelButton: true,
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#b3b1ab',
    //     confirmButtonText: 'ใช่',
    //     cancelButtonText: 'ไม่'
    //   }).then(async result => {
    //     // this.formUpdate.LAST_USER = this.session.data.userName
    //     if (this.filesAdd) {
    //       const _this = this
    //       let params = new FormData()
    //       params.append('file', this.filesAdd[0])
    //       await axios
    //         .post(this.DNS_IP + `/file/upload/reward`, params)
    //         .then(function (response) {
    //           _this.formUpdate.pictureUrl = response.data
    //           console.log('url Pic', response.data)
    //         })
    //     } else {
    //       this.formUpdate.pictureUrl = this.pictureUrlPreview
    //     }
    //     this.updateRew.rewardId = this.formUpdate.rewardId
    //     this.updateRew.pictureUrl = this.formUpdate.pictureUrl
    //     this.updateRew.name = this.formUpdate.name
    //     this.updateRew.subName = this.formUpdate.subName
    //     this.updateRew.point = this.formUpdate.point
    //     this.updateRew.levelId = this.formUpdate.levelId
    //     this.updateRew.description = this.formUpdate.description
    //     this.updateRew.supply = this.formUpdate.supply
    //     this.updateRew.limitType = this.formUpdate.limitType
    //     this.updateRew.startDateReward = this.formUpdate.startDateReward
    //     this.updateRew.endDateReward = this.formUpdate.endDateReward
    //     // this.updateRew.expireTypeReward = this.formUpdate.expireTypeReward
    //     this.updateRew.countExpireReward = this.formUpdate.countExpireReward
    //     this.updateRew.CREATE_USER = this.formUpdate.CREATE_USER
    //     this.updateRew.LAST_USER = this.session.data.userName
    //     this.updateRew.trending = this.formUpdate.trending
    //     this.updateRew.most = this.formUpdate.most
    //     this.updateRew.specialOffer = this.formUpdate.specialOffer
    //     console.log('this.updateRew', this.updateRew)
    //     await axios
    //       .post(
    //         this.DNS_IP + '/reward/edit/' + this.updateRew.rewardId,
    //         this.updateRew
    //       )
    //       .then(async response => {
    //         // Debug response
    //         console.log('addDataGlobal DNS_IP + PATH + "add"', response)

    //         this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
    //       })
    //     if (this.formUpdate.limitType === 'จำกัดจำนวน') {
    //       this.formUpdateCod.expireType = this.formUpdate.expireTypeCode
    //     }
    //     if (this.formUpdate.count > this.formUpdate.quotaCodeUpdate) {
    //       this.formUpdateCod.count =
    //         this.formUpdate.count - this.formUpdate.quotaCodeUpdate
    //       this.formUpdateCod.prefix = this.formUpdate.name.substr(0, 5)
    //       this.formUpdateCod.rewardId = this.formUpdate.rewardId
    //       this.formUpdateCod.genType = 'gen'
    //       this.formUpdateCod.CREATE_USER = this.session.data.userName
    //       this.formUpdateCod.LAST_USER = this.session.data.userName
    //       this.formUpdateCod.redeemStatus = 'open'
    //       this.formUpdateCod.countExpire = this.formUpdate.countExpireCode

    //       if (this.formUpdateCod.expireType === 'Redeem') {
    //         this.formUpdateCod.startDate = ''
    //         this.formUpdateCod.endDate = ''
    //         this.formUpdateCod.count = this.formUpdate.count
    //       } else {
    //         this.formUpdateCod.startDate = this.formUpdate.startDateCode
    //         this.formUpdateCod.endDate = this.formUpdate.endDateCode
    //         this.formUpdateCod.count = 0
    //       }
    //       console.log('formUpdateCod', this.formUpdateCod)
    //       console.log(this.formUpdate.count)
    //       await axios
    //         .post(this.DNS_IP + '/rewardCode/' + 'add', this.formUpdateCod)
    //         .then(async response => {
    //           if (response.data.status === false) {
    //             console.log('response.data.status :', response.data.status)
    //           } else {
    //             this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
    //           }
    //         })
    //         .catch(error => {
    //           console.log('error function addDataGlobal : ', error)
    //           this.$router.push(
    //             '/system/Errorpage?returnLink=' + this.returnLink
    //           )
    //         })
    //       this.formUpdateData = false

    //       await this.getDataReward()
    //     } else if (this.formUpdate.count === this.formUpdate.quotaCodeUpdate) {
    //       console.log(
    //         this.formUpdate.count,
    //         '=',
    //         this.formUpdate.quotaCodeUpdate
    //       )
    //     } else {
    //       this.$swal('ไม่สำเร็จ', 'จำนวนของรางวัลน้อยกว่าเดิม', 'error')
    //     }
    //   })
    // },
    async importData (event) {
      this.dataItemImport = []
      var input = event.target
      var reader = new FileReader()
      reader.onload = () => {
        var fileData = reader.result
        var wb = XLSX.read(fileData, { type: 'binary' })
        wb.SheetNames.forEach(async sheetName => {
          var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName])
          console.log(rowObj)
          for (var i = 0; i < rowObj.length; i++) {
            var d = rowObj[i]
            await axios
              .get(
                this.DNS_IP +
                  '/rewardCode/get?rewardId=' +
                  this.formUpdate.rewardId +
                  '&rewardCode=' +
                  d.rewardCode
              )
              .then(async response => {
                console.log('data', response)
                if (response.data.status === false) {
                  rowObj
                    .map(e => {
                      return e.rewardCode
                    })
                    .indexOf(d.rewardCode) === i
                    ? (d.status = 'True')
                    : (d.status = 'False')
                } else {
                  d.status = 'False'
                }
              })
            this.dataItemImport.push(d)
          }
          console.log('this.dataItemImport : ', this.dataItemImport)
          if (this.dataItemImport.length === 0) {
            alert('โปรดใส่ไฟล์ให้ถูกต้อง')
          } else {
            this.dataItemImportChecKHide = false
          }
        })
      }

      reader.readAsBinaryString(input.files[0])
    },
    importDataApprove (action) {
      console.log('Action', action)
      var titleMsg = ''
      var checkError = false
      if (action === 'add') {
        titleMsg = 'ท่านต้องการ นำเข้าข้อมูลจากไฟล์นี้ ใช่หรือไม่'
      }

      this.$swal({
        title: titleMsg,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loading1 = true
          this.formStatus.dataStatus = []
          this.formStatus.fail = 0
          this.formStatus.sucess = 0
          for (var key in this.dataItemImport) {
            this.PK = this.dataItemImport[key].masBranchID
            if (action === 'add') {
              console.log('add')
              await this.importDataAdd(this.dataItemImport[key])
              checkError = true
            }
          }
          console.log(checkError)
          if (checkError === true) {
            await this.getDataReward(
              this.DNS_IP,
              this.path,
              this.session.data.shopId,
              this.returnLink
            )
            this.clearDataImport()
            // this.$swal('เรียบร้อย', 'เพิ่มข้อมูลสำเร็จ', 'success')
            this.dialogStatus = true
            this.dialogImportExcel = false
          } else {
            this.dataItemImport = []
            this.dataItemImportChecKHide = true
            // alert('โปรดใส่ไฟล์ให้ถูกต้อง')
          }
          this.loading1 = false
        })
        .catch(error => {
          console.log('error function importDataApprove : ', error)
          this.dataReady = true
        })
    },
    async getDataReward () {
      this.updateReward = []
      await axios
        .get(this.DNS_IP + '/reward/get?shopId=' + this.session.data.shopId)
        .then(res => {
          this.updateReward = res.data
          this.update = this.updateReward
          console.log('this.updateReward', this.updateReward)
        })
    },
    async editD (item) {
      await axios
        .get(
          this.DNS_IP +
            '/reward/get?shopId=' +
            this.session.data.shopId +
            '&rewardId=' +
            item.rewardId
        )
        .then(response => {
          let rs = response.data
          console.log('rs', rs)
          this.update.rewardId = rs[0].rewardId
          this.update.pictureUrl = rs[0].pictureUrl
          this.pictureUrlPreview = rs[0].pictureUrl
          this.update.name = rs[0].name
          this.update.subName = rs[0].subName
          this.update.point = rs[0].point
          this.update.levelId = rs[0].levelId
          this.update.description = rs[0].description
          this.update.supply = rs[0].supply
          this.update.limitType = rs[0].limitType
          console.log(this.update)
          // pictureUrl: '',
          // name: '',
          // subName: '',
          // point: '',
          // levelId: '',
          // description: '',
          // supply: '',
          // limitType: '',
          // countExpire: '',
          // startDate: null,
          // endDate: null,
          // trending: '',
          // most: '',
          // specialOffer: '',
          // shopId: this.$session.getAll().data.shopId,
          // CREATE_USER: '',
          // LAST_USER: ''
          axios
            .get(
              this.DNS_IP +
                '/rewardCode/getData?shopId=' +
                this.session.data.shopId +
                '&rewardId=' +
                item.rewardId
            )
            .then(res => {
              console.log('555', res.data)
            })
        })
    },
    clearData () {
      this.addReward.name = ''
      this.addReward.subName = ''
      this.addReward.point = ''
      this.addReward.levelId = 'allLevel'
      this.addReward.description = ''
      this.addReward.supply = 'รับหน้าร้าน'
      this.addReward.limitType = 'ไม่จำกัดจำนวน'
      this.addReward.pictureUrl = ''
      this.addRewardCode.expireType = ''
      this.pictureUrlPreview = ''
      this.filesAdd = null
    }
  }
}
</script>
<style scope>
body {
  color: #4a4a4a;
  font-family: Kanit;
}
.theme--light.v-divider {
  border-color: rgba(0, 0, 0, 0.12);
  margin: 0px 0px;
}
.jus {
  display: flex;
  justify-content: center;
  text-align: center;
}
p {
  font-weight: bold;
  color: #4a4a4a;
  margin-bottom: 0px;
}
.v-text-field {
  padding: 8px 16px !important;
}
.vs-input {
  width: 100% !important;
  background-color: #f2f4f9;
}
.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  background: #f2f4f9;
}
.text-field-no-one {
  padding-top: 0px;
}
/* .v-messages {
  display: none;
} */
/* .v-text-field__details {
  display: none;
} */
.mdi-download::before {
  content: '\F01DA';
  color: white;
}
/* .v-responsive__content {
  margin: auto;
} */
.image-input {
  display: block;
  width: 350px;
  height: 350px;
  /* min-width: 300px;
  min-height: 300px; */
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}

.red {
  color: red;
}
.displayxs {
  display: grid;
  justify-content: end;
}
.displayall {
  display: grid;
  justify-content: center;
}
.v-img-margits {
  width: 135.19px !important;
  height: 137px !important;
}
/* .mdi:before,
.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 'Material Design Icons';
  font-size: 150px;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
} */

.mdi-calendar::before {
  content: '\F00ED';
  color: rgba(0, 0, 0, 0.6);
}
</style>



// WEBPACK FOOTER //
// src/components/Core/testHome.vue